<template>
    <v-row
            align="center"
            justify="center"
            class="grey lighten-5"
            style="height: 300px;"
    >
        <v-col>
            <v-card class="elevation-1">
                <v-card-text>
                    <v-form ref="form">
                        <v-text-field
                                v-model="userInfo.firstName"
                                :label="$t('firstName')"
                                name="FirstName"
                                id="firstName"
                                type="text"
                        ></v-text-field>
                        <v-text-field
                                v-model="userInfo.lastName"
                                :label="$t('lastName')"
                                name="LastName"
                                id="lastName"
                                type="text"
                        ></v-text-field>
                        <!--
                                                    <v-combobox
                                                            v-model="project.name"
                                                            :items="project.list"
                                                            :search-input.sync="dropdown_search"
                                                            item-text="choice"
                                                            hide-selected
                                                            type="button"
                                                            persistent-hint
                                                            small-chips
                                                    ></v-combobox>
                        -->
                        <v-card-actions ><div class="text-right">
                            <v-spacer></v-spacer>
                            <v-btn color="primary mx-2" @click="submit" id="to-survey">{{$t('ToSurvey')}}</v-btn>
                            <v-btn color="primary mx-2 my-2" @click="counterApp" id="to-counter-app">{{$t('counter.goToCounterApp')}}</v-btn>
                        </div>
                        </v-card-actions>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import axios from "axios";
    import config from "../ayalconfig";
    import Vuex, {mapGetters, mapMutations} from "vuex";
    import offlineStorage from "../dbService";

    export default {
        data() {
            return {
                message: "Click on Start Survey to Start your Survey",
                project:{
                    name:'',
                    list:[]
                }
            };
        },
        created(){
            this.$logger.debug("Screen: StartSurvey");
            this.validateGovernmentId()
        },
        computed: {
            ...mapGetters([
                "userInfo"
            ]),
        },
        methods: {
            ...mapMutations({setUser:"saveUserInfo"}),
            async validateGovernmentId(){
                let governmentId = this.fetchGovernmentIdFromState();
                try{
                    let isSet = await this.setUserFromLocalStorage(governmentId);
                    if (!isSet && navigator.onLine){
                        const userInfo = await this.validate(governmentId);
                        this.saveUserInformationToState(userInfo);
                    }
                } catch(error){
                    this.$logger.error("Error validating governmentId. "+error.message);
                    await this.setUserFromLocalStorage(governmentId);
                }
            },
            fetchGovernmentIdFromState(){
                const governmentId = this.userInfo.governmentId;
                if(!governmentId){
                    this.$logger.debug("Government Id not found.");
                    this.$service.redirectToHomePage();
                    return
                }
                return governmentId;
            },

            validate(governmentId){
                this.$logger.debug("GovernmentId found: "+governmentId+" Validating ..");
                const endpoint = `${config.baseUrl()}/login/fetchProfile/`;
                this.$logger.debug("COnnecting to endpoint "+endpoint);
                return axios({
                    method:'post',
                    url: endpoint,
                    data: {governmentId: governmentId}
                })
            },
            saveUserInformationToState(params){
                const userInfo = params.data;
                if(this.userExists(userInfo)) {
                    this.setUser(userInfo.user);
                    const user = userInfo.user;
                    this.saveUserToLocalStorage(user);
                    this.$logger.debug("surveyor with profile: "+ JSON.stringify(user) +" validated");
                    return
                }

                this.$logger.debug("User not found in database.");
            },

            saveUserToLocalStorage(user){
                const governmentId = user.governmentId;
                offlineStorage.setItem(governmentId, user)
            },

            async setUserFromLocalStorage(governmentId){
                let isSuccess = false;
                let userInfoFromLocal = await offlineStorage.getItem(governmentId);
                if (userInfoFromLocal){
                    this.setUser(userInfoFromLocal);
                    isSuccess = true;
                }
                return Promise.resolve(isSuccess);
            },
            async checkAndUpdateUserInfo(){
                let self = this;
                let currentUser = self.userInfo;
                const endpoint = config.user.saveEndpoint;
                let oldUser = await offlineStorage.getItem(currentUser.governmentId);
                if (currentUser){
                    let userInfo = null;
                    try {
                        if (oldUser && (oldUser.firstName === currentUser.firstName && oldUser.lastName === currentUser.lastName)){
                            return
                        }
                        userInfo = await self.callApiEndpoint(currentUser, endpoint);
                        if(this.userExists(userInfo.data)) {
                            this.saveUserToLocalStorage(userInfo.data.user);
                        }
                    }catch (e) {
                        self.$logger.error("Error updating user info due to "+e.message);
                        self.saveUserToLocalStorage(
                            {governmentId: currentUser.governmentId, firstName: currentUser.firstName, lastName:currentUser.lastName});
                    }
                }
            },

            userExists(userInfo){
                return userInfo.success && userInfo.user
            },
            submit: function(){
                this.setEnteredData();
                this.checkAndUpdateUserInfo();
                let surveyNumber = Vuex.Store.surveyNumber;
                if (surveyNumber) {
                  this.$service.navigateTo('Survey', {id:surveyNumber});
                }else {
                  this.$service.navigateTo('Survey');
                }
            },

            counterApp: function(){
                this.$service.navigateTo('CounterApp');
            },
            alert(message) {
                return alert({
                    title: "Ayalon Routes",
                    okButtonText: "OK",
                    message: message
                });
            },
            setEnteredData(){
                this.userInfo.enteredDate = new Date();
            },
            callApiEndpoint(params, endpoint){
                return axios({
                    method:'post',
                    url: endpoint,
                    data: params
                })
            },
        }
    };
</script>
